import { useState, useCallback } from 'react';

export const useDelayedCallback = (callback: () => void, delay: number) => {
  const [inProgress, setInProgress] = useState(false);

  const delayedCallback = useCallback(() => {
    if (delay) {
      setInProgress(true);

      setTimeout(() => {
        callback();
        setInProgress(false);
      }, delay);
    } else {
      callback();
    }
  }, [callback]);

  return [inProgress, delayedCallback];
};
